<template>
    <div class="card rounded-c-3 shadow border-0">
        <form @submit.prevent="register">
            <div class="card-body px-c-5 pt-4 pb-5">
                <div class="form-group mt-4 mb-2">
                    <label for="type" class="form-label"
                        >{{ localise("good_host", "company_type")
                        }}<span class="text-danger ms-1">*</span></label
                    >
                    <select
                        id="type"
                        name="type"
                        class="form-select py-3 rounded-c-3"
                        v-model="type"
                    >
                        <option value="">
                            {{ localise("good_host", "choose_company_type") }}
                        </option>
                        <option value="guest_house">
                            {{ localise("good_host", "accommodation") }}
                        </option>
                    </select>
                    <div v-if="v$.type.required" class="invalid-feedback">
                        {{ localise("validation", "required_field") }}
                    </div>
                </div>
                <div v-if="type">
                    <div class="table-responsive mt-4 mb-2">
                        <table class="table table-hover table-bordered">
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        <small>#</small>
                                    </th>
                                    <th class="w-75">
                                        <small
                                            >ზოგადი კრიტერიუმები /
                                            მოთხოვნები</small
                                        >
                                    </th>
                                    <th class="text-center">
                                        <small>{{
                                            localise(
                                                "good_host",
                                                "select_question"
                                            )
                                        }}</small>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-center">
                                        <small>1</small>
                                    </td>
                                    <td>
                                        <small>
                                            ობიექტი რეგისტრირებულია ეკონომიკურ
                                            საქმიანობათა რეესტრში მოქმედი
                                            კანონმდებლობის შესაბამისად
                                        </small>
                                    </td>
                                    <td>
                                        <div
                                            class="form-check d-flex align-items-center gap-4"
                                        >
                                            <div class="form-check">
                                                <input
                                                    class="form-check-input cursor-pointer"
                                                    type="radio"
                                                    name="requirement_one"
                                                    id="requirement_one_yes"
                                                    v-model="requirement_one"
                                                    :value="true"
                                                />
                                                <label
                                                    class="form-check-label cursor-pointer"
                                                    for="requirement_one_yes"
                                                >
                                                    დიახ
                                                </label>
                                            </div>
                                            <div class="form-check">
                                                <input
                                                    class="form-check-input cursor-pointer"
                                                    type="radio"
                                                    name="requirement_one"
                                                    id="requirement_one_no"
                                                    v-model="requirement_one"
                                                    :value="false"
                                                />
                                                <label
                                                    class="form-check-label cursor-pointer"
                                                    for="requirement_one_no"
                                                >
                                                    არა
                                                </label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <small>2</small>
                                    </td>
                                    <td>
                                        <small>
                                            ობიექტი რეგისტრირებულია არანაკლებ
                                            ერთი წელი ტურისტულ საინფომაციო
                                            ბაზაში და იყოს რეგისტრირებული
                                            მომხმარებელი რომელიმე განთავსების
                                            საერთაშორისო პორტალზე
                                        </small>
                                    </td>
                                    <td>
                                        <div
                                            class="form-check d-flex align-items-center gap-4"
                                        >
                                            <div class="form-check">
                                                <input
                                                    class="form-check-input cursor-pointer"
                                                    type="radio"
                                                    name="requirement_two"
                                                    id="requirement_two_yes"
                                                    v-model="requirement_two"
                                                    :value="true"
                                                />
                                                <label
                                                    class="form-check-label cursor-pointer"
                                                    for="requirement_two_yes"
                                                >
                                                    დიახ
                                                </label>
                                            </div>
                                            <div class="form-check">
                                                <input
                                                    class="form-check-input cursor-pointer"
                                                    type="radio"
                                                    name="requirement_two"
                                                    id="requirement_two_no"
                                                    v-model="requirement_two"
                                                    :value="false"
                                                />
                                                <label
                                                    class="form-check-label cursor-pointer"
                                                    for="requirement_two_no"
                                                >
                                                    არა
                                                </label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div
                        v-if="requirement_one && requirement_two"
                        class="col-12"
                    >
                        <div class="table-responsive mt-4 mb-2">
                            <table
                                v-for="question in questions"
                                class="table table-hover table-bordered"
                            >
                                <thead>
                                    <tr>
                                        <th class="text-center">
                                            <small>#</small>
                                        </th>
                                        <th class="w-75">
                                            <small>{{
                                                question[
                                                    `title_${$store.state.locale}`
                                                ]
                                            }}</small>
                                        </th>
                                        <th class="text-center">
                                            <small>{{
                                                localise(
                                                    "good_host",
                                                    "select_question"
                                                )
                                            }}</small>
                                        </th>
                                        <th class="text-center">
                                            <small>{{
                                                localise(
                                                    "good_host",
                                                    "relevant"
                                                )
                                            }}</small>
                                        </th>
                                        <th class="text-center">
                                            <small>{{
                                                localise("good_host", "comment")
                                            }}</small>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="child in question.questions">
                                        <td class="text-center">
                                            <small>{{ child.position }}</small>
                                        </td>
                                        <td>
                                            <small>
                                                {{
                                                    child[
                                                        `title_${$store.state.locale}`
                                                    ]
                                                }}
                                                <br v-if="child.comment" />
                                                <div
                                                    v-if="child.comment"
                                                    class="p-3 bg-light rounded-c-3 shadow-sm"
                                                >
                                                    {{
                                                        localise(
                                                            "good_host",
                                                            "comment"
                                                        )
                                                    }}:
                                                    <strong>{{
                                                        child.comment
                                                    }}</strong>
                                                </div>
                                            </small>
                                        </td>
                                        <td class="text-center">
                                            <div class="form-check">
                                                <input
                                                    class="form-check-input checkbox-padding rounded-3 cursor-pointer mx-auto"
                                                    type="checkbox"
                                                    :id="child.id"
                                                    :value="child"
                                                    v-model="selectedQuestions"
                                                />
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <span
                                                class="badge rounded-pill px-3 py-2 shadow-sm badge-font-size"
                                                :class="
                                                    child.required
                                                        ? 'bg-success'
                                                        : 'bg-primary'
                                                "
                                            >
                                                <small>{{
                                                    child.required
                                                        ? localise(
                                                              "good_host",
                                                              "required"
                                                          )
                                                        : localise(
                                                              "good_host",
                                                              "recommended"
                                                          )
                                                }}</small>
                                            </span>
                                        </td>
                                        <td class="text-center">
                                            <button
                                                v-if="!child.comment"
                                                type="button"
                                                class="btn btn-c-primary rounded-c-3 text-white shadow-sm font-small"
                                                @click="changeId(child.id)"
                                                data-bs-toggle="modal"
                                                data-bs-target="#commentModal"
                                            >
                                                {{
                                                    localise(
                                                        "good_host",
                                                        "add_comment"
                                                    )
                                                }}
                                            </button>
                                            <button
                                                v-else
                                                type="button"
                                                class="btn btn-c-primary rounded-c-3 text-white shadow-sm font-small"
                                                @click="removeComment(child.id)"
                                            >
                                                {{
                                                    localise(
                                                        "good_host",
                                                        "remove_comment"
                                                    )
                                                }}
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="form-group mt-4 mb-2">
                            <label for="name" class="form-label"
                                >{{ localise("good_host", "company_name")
                                }}<span class="text-danger ms-1">*</span></label
                            >
                            <input
                                id="name"
                                name="name"
                                type="text"
                                class="form-control py-3 rounded-c-3"
                                :class="v$.name.$error ? 'is-invalid' : ''"
                                v-model="name"
                            />
                            <div
                                v-if="v$.name.minLength"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "min5") }}
                            </div>
                        </div>
                        <div class="form-group mt-4 mb-2">
                            <label for="contact_person" class="form-label"
                                >{{ localise("good_host", "contact_person")
                                }}<span class="text-danger ms-1">*</span></label
                            >
                            <input
                                id="contact_person"
                                name="contact_person"
                                type="text"
                                class="form-control py-3 rounded-c-3"
                                :class="
                                    v$.contact_person.$error ? 'is-invalid' : ''
                                "
                                v-model="contact_person"
                            />
                            <div
                                v-if="v$.contact_person.minLength"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "min5") }}
                            </div>
                        </div>
                        <div class="form-group mt-4 mb-2">
                            <label for="email" class="form-label"
                                >{{ localise("tour_form", "email")
                                }}<span class="text-danger ms-1">*</span></label
                            >
                            <input
                                id="email"
                                name="email"
                                type="text"
                                class="form-control py-3 rounded-c-3"
                                :class="v$.email.$error ? 'is-invalid' : ''"
                                v-model="email"
                            />
                            <div
                                v-if="v$.email.$error"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "email") }}
                            </div>
                        </div>
                        <div class="form-group mt-4 mb-2">
                            <label for="phone" class="form-label"
                                >{{ localise("tour_form", "phone")
                                }}<span class="text-danger ms-1">*</span></label
                            >
                            <input
                                id="phone"
                                name="phone"
                                type="number"
                                class="form-control py-3 rounded-c-3"
                                :class="v$.phone.$error ? 'is-invalid' : ''"
                                v-model="phone"
                            />
                            <div
                                v-if="v$.phone.$error"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "phone") }}
                            </div>
                        </div>
                        <div class="form-group mt-4 mb-2">
                            <label for="website" class="form-label">{{
                                localise("good_host", "website")
                            }}</label>
                            <input
                                id="website"
                                name="website"
                                type="text"
                                class="form-control py-3 rounded-c-3"
                                v-model="website"
                            />
                            <div
                                v-if="v$.website.$error"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "min10") }}
                            </div>
                        </div>
                        <div class="form-group mt-4 mb-2">
                            <label for="facebook" class="form-label"
                                >Facebook
                                {{ localise("good_host", "link") }}</label
                            >
                            <input
                                id="facebook"
                                name="facebook"
                                type="text"
                                class="form-control py-3 rounded-c-3"
                                v-model="facebook"
                            />
                            <div
                                v-if="v$.facebook.$error"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "min10") }}
                            </div>
                        </div>
                        <div class="text-center mt-3">
                            <button
                                v-if="!$store.state.loading"
                                type="submit"
                                class="btn btn-lg btn-c-secondary rounded-c-3 px-5 py-4 fs-6 text-white shadow mt-4 w-100"
                            >
                                {{ localise("tour_form", "button") }}
                                <i class="fas fa-check-circle ms-1"></i>
                            </button>
                            <div
                                v-else
                                class="spinner-grow text-dark mt-3"
                                role="status"
                            >
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <CommentModal :id="id" @addedComment="(event) => addComment(event)" />
</template>

<script>
import translations from "../../helpers/translations";
import useVuelidate from "@vuelidate/core";
import { required, email, minLength, maxLength } from "@vuelidate/validators";
import { questions, goodHostRegister } from "../../services/InternalApiService";
import CommentModal from "../others/CommentModal.vue";

export default {
    name: "GoodHostRegistration",
    components: { CommentModal },
    setup() {
        return {
            v$: useVuelidate(),
        };
    },
    data() {
        return {
            type: "",
            name: "",
            contact_person: "",
            email: "",
            phone: "",
            website: "",
            facebook: "",
            questions: [],
            selectedQuestions: [],
            comments: [],
            id: "",
            requirement_one: false,
            requirement_two: false,
        };
    },
    validations() {
        return {
            type: { required },
            name: { required, minLength: minLength(5) },
            contact_person: { required, minLength: minLength(5) },
            email: { required, email },
            phone: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(9),
            },
            website: { minLength: minLength(5) },
            facebook: { minLength: minLength(10) },
        };
    },
    methods: {
        register() {
            this.v$.$validate();
            this.v$.$touch();
            if (!this.v$.$invalid) {
                this.$store.state.loading = true;
                setTimeout(() => {
                    goodHostRegister({
                        type: this.type,
                        name: this.name,
                        contact_person: this.contact_person,
                        email: this.email,
                        phone: this.phone,
                        website: this.website,
                        facebook: this.facebook,
                        answers: this.questions.reduce((acc, question) => {
                            question.questions.forEach((child) => {
                                const selectedQuestion =
                                    this.selectedQuestions.find(
                                        (q) => q.id === child.id
                                    );
                                const comment = this.comments.find(
                                    (c) => c.id === child.id
                                );

                                if (selectedQuestion || comment) {
                                    acc.push({
                                        id: child.id,
                                        checked: selectedQuestion
                                            ? true
                                            : false,
                                        comment: comment ? comment.comment : "",
                                    });
                                }
                            });

                            return acc;
                        }, []),
                    })
                        .then((res) => {
                            this.$store.state.loading = false;
                            if (res.status === 200) {
                                Swal.fire({
                                    position: "center",
                                    icon: res.data.data.icon,
                                    title:
                                        res.data.data.icon === "error"
                                            ? ""
                                            : this.localise(
                                                  "tour_form",
                                                  "success_message"
                                              ),
                                    text: res.data.data.text,
                                    showConfirmButton: true,
                                    confirmButtonText: this.localise(
                                        "good_host",
                                        "close"
                                    ),
                                });
                                this.clearInputs();
                            } else {
                                Swal.fire({
                                    position: "center",
                                    icon: "warning",
                                    title: this.localise("validation", "error"),
                                    showConfirmButton: false,
                                    timer: 1500,
                                });
                            }
                        })
                        .catch((error) => {
                            this.$store.state.loading = false;
                            Swal.fire({
                                position: "center",
                                icon: "warning",
                                title: this.localise("validation", "error"),
                                showConfirmButton: false,
                                timer: 1500,
                            });
                            console.log(error);
                        });
                }, 0);
            } else {
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: this.localise("validation", "error"),
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        },
        async getQuestions() {
            try {
                const response = await questions();
                this.questions = response.data;
            } catch (error) {
                console.log(error);
            }
        },
        clearInputs() {
            this.type = "";
            this.name = "";
            this.contact_person = "";
            this.email = "";
            this.phone = "";
            this.website = "";
            this.facebook = "";
            this.selectedQuestions = [];
            this.comments = [];
            this.requirement_one = false;
            this.requirement_two = false;

            this.v$.$reset();
            this.getQuestions();
        },
        localise(cat, key) {
            return translations[this.$store.state.locale][cat][key];
        },
        addComment(data) {
            this.comments.push(data);

            this.questions.forEach((question) => {
                question.questions.filter((item) => {
                    if (item.id === data.id) {
                        item.comment = data.comment;
                    }
                    return true;
                });
            });

            this.closeModal();
        },
        removeComment(id) {
            this.comments.filter((comment) => {
                return comment.id !== id;
            });

            this.questions.forEach((question) => {
                question.questions.filter((item) => {
                    if (item.id === id) {
                        item.comment = "";
                    }
                    return true;
                });
            });
        },
        changeId(id) {
            this.id = id;
        },
        closeModal() {
            let commentModal = document.querySelector(".modal.show");
            let modal = bootstrap.Modal.getInstance(commentModal);
            modal.hide();
        },
    },
    mounted() {
        this.getQuestions();
    },
};
</script>

<style scoped>
.font-small {
    font-size: 12px;
}

.checkbox-padding {
    padding: 14px;
}

.badge-font-size {
    font-size: 13px;
}
</style>
